export const otherSkillsMock = [
  {
    otherSkill: {
      src: "/images/skills/webpack.png",
      alt: "webpack",
      width: "70",
      height: "70",
    },
  },
  {
    otherSkill: {
      src: "/images/skills/git.png",
      alt: "git",
      width: "60",
      height: "60",
    },
  },
  {
    otherSkill: {
      src: "/images/skills/datadog.png",
      alt: "datadog",
      width: "60",
      height: "60",
    },
  },
  {
    otherSkill: {
      src: "/images/skills/docker.png",
      alt: "docker",
      width: "60",
      height: "60",
    },
  },
];
